import React from 'react';
import { CONSTANTS } from '../../constants/constants';

const { USED, NOT_USED } = CONSTANTS.PARTS_USAGE_ANSWER;

const PartDetail = ({ label, value }) => (
  <span className="parts-usage-detail">
    <small>{label}</small> <span>{value}</span>
  </span>
);

const PartLine = ({ taskId, part, disabled, onAnswer, t }) => {
  const groupName = `parts-usage-${taskId}-${part.lineKey}`;
  const choices = [
    { value: USED, label: t('usageUsed') },
    { value: NOT_USED, label: t('usageNotUsed') },
  ];

  return (
    <div className="parts-usage-line" data-testid={`part-${part.lineKey}`}>
      <div className="parts-usage-details">
        <PartDetail label={t('code')} value={part.code} />
        <PartDetail label={t('partNumber')} value={part.partNumber} />
        <PartDetail label={t('description')} value={part.name} />
        {part.serial && <PartDetail label={t('serialN')} value={part.serial} />}
      </div>
      <div className="parts-usage-choices" role="radiogroup" aria-label={`${part.code} ${part.partNumber}`}>
        {choices.map((choice) => (
          <label key={choice.value} className="parts-usage-choice">
            <input
              type="radio"
              name={groupName}
              checked={part.answer === choice.value}
              disabled={disabled}
              onChange={() => onAnswer(part.lineKey, choice.value)}
            />{' '}
            {choice.label}
          </label>
        ))}
        {part.answer && (
          <button
            type="button"
            className="parts-usage-clear"
            disabled={disabled}
            onClick={() => onAnswer(part.lineKey, null)}
          >
            {t('clear')}
          </button>
        )}
      </div>
    </div>
  );
};

// Built-in task listing every part of the work order, one line per unit, with a Used / Not used
// answer each. `disabled` locks the whole task once it has been submitted.
const PartsUsageTask = ({ task, disabled, onAnswer, onNotApplicable, t }) => {
  const partsUsage = task.taskData?.partsUsage;
  if (!Array.isArray(partsUsage?.parts)) return null;

  return (
    <div className="task-entry parts-usage-task">
      <div>{task.taskData.description}</div>
      <p className="parts-usage-helper">{t('partsUsageHelper')}</p>
      <label className="parts-usage-not-applicable">
        <input
          type="checkbox"
          checked={Boolean(partsUsage.notApplicable)}
          disabled={disabled || partsUsage.parts.length === 0}
          onChange={(event) => onNotApplicable(event.target.checked)}
        />{' '}
        {t('notApplicable')}
      </label>
      {partsUsage.parts.map((part) => (
        <PartLine
          key={part.lineKey}
          taskId={task.id}
          part={part}
          disabled={disabled || partsUsage.notApplicable}
          onAnswer={onAnswer}
          t={t}
        />
      ))}
    </div>
  );
};

export default PartsUsageTask;
